export default __webpack_public_path__ + "static/media/SD-gallery-03.478a0f1b.png";